function openConfirm(confirmsState, confirmType, confirmProps = {}) {
	return [...confirmsState, {
		type: confirmType,
		props: confirmProps,
	}]
}

function closeConfirm(confirmsState, confirmType) {
	return confirmsState.filter(confirm => confirm.type !== confirmType)
}

export {
	openConfirm,
	closeConfirm,
}
